import { Switch, Route } from 'react-router-dom';
import OopsPage from './pages/oops-page';
import PrimaryErrorBoundary from './error-boundaries/primary';
import PrimaryLayout from './layouts/primary';
import React from 'react';
import SelfServicePage from './pages/self-service-page';
import StaticLayout from './layouts/static';
import QuotesPage from './pages/quotes-page';

import '../styles/app.scss';

// Internal
// --------

function App() {
  //
  // Render

  const isMobileApp = /TutoringTools/gi.test(window.navigator.userAgent);

  return (
    <PrimaryErrorBoundary>
      <Switch>
        <Route exact path="/oops">
          <StaticLayout {...{ isMobileApp }}>
            <OopsPage />
          </StaticLayout>
        </Route>

        <Route exact path="/tutoring-packages">
          <PrimaryLayout {...{ isMobileApp }}>
            <SelfServicePage />
          </PrimaryLayout>
        </Route>

        <Route exact path="/quotes">
          <PrimaryLayout {...{ isMobileApp }}>
            <QuotesPage />
          </PrimaryLayout>
        </Route>
      </Switch>
    </PrimaryErrorBoundary>
  );
}

// Exports
// -------

export default App;
